
/**
 * Type of tweet
 */
export type GetTweetFeed200TweetsItemTweetType = typeof GetTweetFeed200TweetsItemTweetType[keyof typeof GetTweetFeed200TweetsItemTweetType];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const GetTweetFeed200TweetsItemTweetType = {
  ORIGINAL: 'ORIGINAL',
  REPLY: 'REPLY',
  QUOTE: 'QUOTE',
} as const;
